<template>
	<div class="essay">
		<div class="fixation">
			<div class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item class="bread-red">{{categoryName}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="main">
				<div class="content">
					<div class="title">
						{{title}}
					</div>
					<div class="date">
						<div class="time">
							{{time}}
						</div>
						<div class="source">
							来源：{{source}}
						</div>
					</div>
					<div class="cont" v-html="article">

					</div>
					<div class="about">
						<div class="about-title">
							相关问题：
						</div>
						<ul>
							<li v-for="(item,index) in about" :key="index" @click="useThisArticle(item)">
								<div class="point">
									<span></span>
								</div>
								<div class="about-name">
									{{item.articleName}}
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="recommend">
					<div class="activity">
						<div class="title">
							最新活动
						</div>
						<div class="image">
							<router-link to="">
								<img src="../../../assets/laws-2.png" alt="">
							</router-link>
						</div>
						<div class="image">
							<router-link to="">
								<img src="../../../assets/laws-4.jpg" alt="">
							</router-link>
						</div>
					</div>
					<div class="other">
						<div class="post" v-for="(item,index) in list" :key="index" v-show="item['tabs'].length>0">
							<div class="title">
								{{item.name}}
							</div>
							<div class="list">
								<li v-for="(tab,tabIndex) in item['tabs']" :key="tabIndex" @click="useThisArticle(tab)">
									{{tab.articleName}}
								</li>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'essay',
		data() {
			return {
				categoryName: '',
				title: '',
				time: '',
				source: '',
				article: '',
				list: [],
				about: [],
				id: ''
			};
		},
		methods: {
			fetchData() {
				this.$api.frontArticleDetail({
					articleId: this.id
				}, res => {
					if (res.code == 200) {
						let current = res.data[0]
						this.title = current.articleName
						this.time = current.createAt
						this.source = current.articleSource
						this.article = current.articleContent
						this.about = res.data[1]
					}
				})
			},
			useThisArticle(item){
				this.$router.push({
					path:'/essay',
					query:{
						id:item.articleId
					}
				})
				location.reload()
			},
			fetchList(){
				let category = JSON.parse(sessionStorage.getItem('category'))
				for (let i = 0; i < category.length; i++) {
					this.$api.frontArticleList({
						pageSize: 6,
						pageNum: 1,
						articleTwoType: category[i]['id']
					}, res => {
						if (res.code == 200) {
							category[i]['tabs'] = res.data.list
							this.list.push(category[i])
						}
					})
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
			this.categoryName = this.$route.query.category
			this.fetchData()
			this.fetchList()
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.essay {
		width: 100%;
		background: @vue-bg-color-grey;
		padding: @vue-spacing-col-lg 0px;
		box-sizing: border-box;

		.bread {
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;
		}

		.main {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.content {
				width: 850px;
				background: @vue-bg-color;
				padding: @vue-spacing-col-base @vue-spacing-row-lg;
				box-sizing: border-box;
				border-radius: @vue-border-radius-lg;
				box-shadow: 0px 0px 8px @vue-border-color;

				.title {
					width: 100%;
					padding: @vue-spacing-col-base 0px;
					box-sizing: border-box;
					line-height: 40px;
					font-size: @vue-font-size-base;
					text-align: center;
				}

				.date {
					width: 100%;
					height: 40px;
					border-bottom: 1px solid @vue-border-color;
					display: flex;
					justify-content: space-between;

					.time,
					.source {
						height: 100%;
						display: flex;
						align-items: center;
						color: @vue-text-color-grey;
						font-size: @vue-font-size-sm - 2;
					}
				}

				.cont {
					width: 100%;
					margin-top: @vue-spacing-col-base;
					line-height: 30px;
				}

				.about {
					width: 100%;
					margin-top: @vue-spacing-col-lg;
					border-top: 1px solid @vue-border-color;

					.about-title {
						width: 100%;
						height: 50px;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-sm;
						margin-top: @vue-spacing-col-base;
					}

					ul,
					li {
						width: 100%;
					}

					li {
						height: 40px;
						display: flex;
						cursor: pointer;

						.point {
							width: 20px;
							height: 100%;
							display: flex;
							align-items: center;

							span {
								width: 8px;
								height: 8px;
								border-radius: @vue-border-radius-circle;
								background: @vue-bg-color-red;
							}
						}

						.about-name {
							width: calc(100% - 40px);
							height: 100%;
							display: flex;
							align-items: center;
							font-size: @vue-font-size-sm - 2;
						}
					}

					li:hover {
						color: @vue-text-color-active;
					}
				}
			}

			.recommend {
				width: 320px;

				.post,
				.activity {
					width: 100%;

					.title {
						width: 100%;
						height: 50px;
						display: flex;
						align-items: center;
					}

					.list {
						width: 100%;
						background: @vue-bg-color;
						border-radius: @vue-border-radius-lg;
						padding: @vue-spacing-col-sm @vue-spacing-row-sm;
						box-sizing: border-box;
						box-shadow: 0px 0px 8px @vue-border-color;

						li {
							width: 100%;
							height: 40px;
							line-height: 40px;
							color: @vue-text-color-grey;
							font-size: @vue-font-size-sm - 2;
							cursor: pointer;
						}

						li:hover {
							color: @vue-text-color-active;
						}
					}

					.image {
						width: 100%;
						margin-bottom: @vue-spacing-col-base;
						border-radius: @vue-border-radius-lg;
						overflow: hidden;

						a,
						img {
							width: 100%;
							display: block;
						}
					}

					.image:last-child {
						margin: 0px;
					}
				}
			}
		}
	}
</style>
